import { useProductTour, TOUR_STEPS } from '@/hooks/useProductTour';
import { TourOverlay } from './TourOverlay';
import { TourTooltip } from './TourTooltip';

export function TourController() {
  const { isActive, currentStep, skipTour, advanceStep, completeTour, getCurrentStepData } = useProductTour();
  
  const stepData = getCurrentStepData();

  if (!isActive || !stepData) return null;

  // Final celebration step has no target — auto-complete on dismiss
  const isFinalStep = stepData.action === 'auto-complete';
  const handleNext = isFinalStep ? completeTour : advanceStep;

  return (
    <>
      <TourOverlay
        targetSelector={stepData.targetSelector}
        isActive={isActive}
      />
      <TourTooltip
        step={stepData}
        currentStepIndex={currentStep}
        totalSteps={TOUR_STEPS.length}
        onSkip={skipTour}
        onNext={handleNext}
        isFinalStep={isFinalStep}
      />
    </>
  );
}
